var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteBuilding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 29.3207V5.33103C7.99658 4.62409 8.27741 3.94611 8.77729 3.44622C9.27717 2.94634 9.95516 2.66551 10.6621 2.66551H21.3242C22.0311 2.66551 22.7091 2.94634 23.209 3.44622C23.7089 3.94611 23.9897 4.62409 23.9897 5.33103V29.3207H7.99658Z",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99656 15.9931H5.33104C4.6241 15.9931 3.94612 16.2739 3.44624 16.7738C2.94636 17.2737 2.66553 17.9517 2.66553 18.6586V26.6552C2.66553 27.3621 2.94636 28.0401 3.44624 28.54C3.94612 29.0399 4.6241 29.3207 5.33104 29.3207H7.99656",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9897 11.9948H26.6553C27.3622 11.9948 28.0402 12.2757 28.5401 12.7755C29.0399 13.2754 29.3208 13.9534 29.3208 14.6603V26.6552C29.3208 27.3621 29.0399 28.0401 28.5401 28.54C28.0402 29.0399 27.3622 29.3207 26.6553 29.3207H23.9897",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3276 7.99655H18.6587",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3276 13.3276H18.6587",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3276 18.6586H18.6587",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3276 23.9897H18.6587",
    stroke: "white",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBuilding);
export default __webpack_public_path__ + "static/media/white_building.7b58de0825c17859b3dfccd0b0b42e0d.svg";
export { ForwardRef as ReactComponent };